// extracted by mini-css-extract-plugin
module.exports = {"header-logo":"styles-module__header-logo___3pdK2"};